// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import ChevronLeft from "@insite/mobius/Icons/ChevronLeft";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import PanelMenuDefaultProps from "@insite/mobius/PanelMenu/presentationProps";
import { xBaseTheme } from "@tps/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...PanelMenuDefaultProps,
        bodyColor: "text.main",
        childTypographyProps: {
            css: css`
                font-size: 14px;
                font-weight: normal;
                letter-spacing: 0;
                line-height: 22px;
            `,
        },
        panelRowProps: {
            color: "text.main",
            moreIconProps: {
                src: ChevronRight,
                size: 20,
                color: "primary.main",
                css: css`
                    &${IconWrapper} {
                        flex-grow: 1;
                        justify-content: flex-end;
                        &, & > svg {
                            width: 20px;
                            height: 20px;
                        }
                    }
                `,
                
            },
        },
        backIconProps: {
            color: "primary.main",
            src: ChevronLeft,
            size: 20,
            css: css`
                &&& {
                    top: 0;
                }
            `,
        },
    },
} as xBaseTheme["panelMenu"];
